var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "col-12" }, [_c("email-preferences-loader")], 1)
    : _c("email-preferences", {
        ref: "emailPreferences",
        attrs: {
          "account-preferences": _vm.accountPreferences,
          "synced-emails": _vm.syncedEmails,
          "nylas-account": _vm.nylasAccount,
        },
        on: {
          "clear-nylas-account": function ($event) {
            return _vm.$emit("clear-nylas-account")
          },
          "allow-save": _vm.handleAllowSave,
          submit: _vm.handleSubmit,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }